/**
 * EntityAbilitySystem — Single Responsibility: tick de timers de habilidades y CC.
 *
 * Opera sobre un objeto de estado plano (duck-typed) — compatible con Entity y con stubs.
 * NO contiene lógica de casting (eso es responsabilidad de Entity.activateQ/castW/etc.).
 * NO importa Three.js, DOM ni ningún sistema de presentación.
 *
 * Contrato público (todas son funciones puras que mutan el estado dado, retornan void):
 *   tickStunTimer(state, dt)
 *   tickHawkVision(state, dt)
 *   tickAbilityCooldowns(state, dt)
 *   tickManaRegen(state, dt)
 */

/**
 * Reduce el timer de stun y lo limpia al expirar.
 * @param {{ isStunned: boolean, stunTimer: number }} state
 * @param {number} dt
 */
export function tickStunTimer(state, dt) {
  if (state.stunTimer <= 0) return;
  state.stunTimer -= dt;
  if (state.stunTimer <= 0) {
    state.stunTimer = 0;
    state.isStunned = false;
  }
}

/**
 * Reduce el timer de visión de halcón y lo limpia al expirar.
 * @param {{ revealedByHawk: boolean, hawkVisionTimer: number }} state
 * @param {number} dt
 */
export function tickHawkVision(state, dt) {
  if (state.hawkVisionTimer <= 0) return;
  state.hawkVisionTimer -= dt;
  if (state.hawkVisionTimer <= 0) {
    state.hawkVisionTimer = 0;
    state.revealedByHawk = false;
  }
}

/**
 * Reduce los cooldowns de Q/W/E/R por dt.
 * Si Q está activa, también decrementa qTimer y la desactiva al expirar.
 * @param {{
 *   qActive: boolean, qTimer: number, qCooldown: number, maxQCooldown: number,
 *   wCooldown: number, eCooldown: number, rCooldown: number
 * }} state
 * @param {number} dt
 */
export function tickAbilityCooldowns(state, dt) {
  // Q: modo activo vs cooldown
  if (state.qActive) {
    state.qTimer -= dt;
    if (state.qTimer <= 0) {
      state.qActive = false;
      state.qTimer = 0;
      state.qCooldown = state.maxQCooldown;
    }
  } else if (state.qCooldown > 0) {
    state.qCooldown = Math.max(0, state.qCooldown - dt);
  }

  if (state.wCooldown > 0) state.wCooldown = Math.max(0, state.wCooldown - dt);
  if (state.eCooldown > 0) state.eCooldown = Math.max(0, state.eCooldown - dt);
  if (state.rCooldown > 0) state.rCooldown = Math.max(0, state.rCooldown - dt);
}

/**
 * Regeneración pasiva de maná.
 * @param {{ mp: number, maxMp: number, mpRegen: number, isDead: boolean }} state
 * @param {number} dt
 */
export function tickManaRegen(state, dt) {
  if (state.isDead || state.maxMp <= 0) return;
  state.mp = Math.min(state.maxMp, state.mp + state.mpRegen * dt);
}
